import { __assign } from "tslib";
// DS: I11
// from GDrive
import React from 'react';
import IconWrap from '../IconWrap';
export function getFavouriteIconMarkup(className) {
    return (React.createElement("path", { className: className, d: "M9.98 2L7.49 6.54l-5.5.8L1 10.49l3.95 3.85-.93 5.45 2.74 1.96 4.84-2.55 4.93 2.57 2.69-1.96-.97-5.47 3.95-3.85-1.03-3.12-5.5-.8L13.177 2z" }));
}
var Favourite = function (props) {
    return (React.createElement(IconWrap, __assign({}, props),
        React.createElement("svg", { width: "0", height: "0", viewBox: "0 0 24 24", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, getFavouriteIconMarkup())));
};
Favourite.displayName = 'Favourite';
export default Favourite;
//# sourceMappingURL=Favourite.js.map